var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeightSilhouetteForMedicalSportPracticeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#333062",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 31.887 31.887",
    xmlSpace: "preserve",
    stroke: "#333062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.206,14.272h-0.11v-0.938c0-0.895-0.726-1.621-1.621-1.621h-0.467v-1.305c0-0.895-0.727-1.621-1.621-1.621h-2.713 c-0.895,0-1.619,0.726-1.619,1.621v3.864H9.937v-3.864c0-0.895-0.727-1.621-1.621-1.621H5.603c-0.894,0-1.62,0.726-1.62,1.621 v1.305h-0.47c-0.894,0-1.62,0.726-1.62,1.621v0.938H1.68c-0.926,0-1.68,0.744-1.68,1.672c0,0.927,0.754,1.671,1.68,1.671h0.213 v0.938c0,0.896,0.726,1.621,1.62,1.621h0.47v1.305c0,0.895,0.726,1.621,1.62,1.621h2.713c0.894,0,1.621-0.727,1.621-1.621v-3.863 h12.118v3.863c0,0.895,0.725,1.621,1.619,1.621h2.713c0.896,0,1.621-0.727,1.621-1.621v-1.305h0.467 c0.896,0,1.621-0.726,1.621-1.621v-0.938h0.109c0.928,0,1.682-0.744,1.682-1.671C31.887,15.016,31.135,14.272,30.206,14.272z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightSilhouetteForMedicalSportPracticeSvgrepoCom);
export default __webpack_public_path__ + "static/media/weight-silhouette-for-medical-sport-practice-svgrepo-com.f8cb71d06ce0a92c51912c0aecbed8a5.svg";
export { ForwardRef as ReactComponent };